export default __webpack_public_path__ + "static/media/image.c58815b9.svg";